import { useMemo } from "react";
import { usePagedFeed } from "@/pages/leads/lead-details/activities/shared/use-paged-feed";
import { getLeadInteractions, type TLeadInteraction } from "@/services/interactions.service";
import { useSmsRefreshStore } from "@/store/sms/sms-refresh.store";
import { toMessage } from "./use-sms-thread";

/**
 * A lead's whole text history, paged like the Emails tab (GET /lead/{id}/interactions?type=sms,
 * `total` counts both directions). `messages` run oldest first, so the newest sits at the bottom.
 * A messaging socket event for the lead refreshes the first page in place.
 */
export function useSmsConversation(leadId: number) {
  const smsVersion = useSmsRefreshStore((s) => s.versionByLead[leadId] ?? 0);
  const { items, total, remaining, loading, loadingMore, loadMore } = usePagedFeed<TLeadInteraction>(
    `sms:${leadId}`,
    (page, size) => getLeadInteractions(leadId, page, size, "sms"),
    `${leadId}:${smsVersion}`
  );
  // The API pages newest first.
  const messages = useMemo(() => items.map(toMessage).reverse(), [items]);

  return { messages, total, remaining, loading, loadingMore, loadMore };
}
